// Utility function to open base64 files in a new window
export const openBase64File = (base64Data: string, fileName: string = 'Dokument') => {
  try {
    // Detect MIME type from base64 string
    let mimeType = 'application/pdf';
    let fileExtension = 'pdf';
    
    if (base64Data.includes('data:image/jpeg') || base64Data.includes('data:image/jpg')) {
      mimeType = 'image/jpeg';
      fileExtension = 'jpg';
    } else if (base64Data.includes('data:image/png')) {
      mimeType = 'image/png';
      fileExtension = 'png';
    } else if (base64Data.includes('data:application/pdf')) {
      mimeType = 'application/pdf';
      fileExtension = 'pdf';
    }

    // Convert base64 to blob
    const base64WithoutPrefix = base64Data.split(',')[1] || base64Data;
    const binaryString = window.atob(base64WithoutPrefix);
    const bytes = new Uint8Array(binaryString.length);
    
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    const blob = new Blob([bytes], { type: mimeType });
    const blobUrl = URL.createObjectURL(blob);
    
    // Open in new window
    const win = window.open(blobUrl, '_blank');
    
    if (win) {
      win.document.title = `${fileName}.${fileExtension}`;
      
      // Clean up blob URL after window is loaded
      win.onload = () => {
        setTimeout(() => {
          URL.revokeObjectURL(blobUrl);
        }, 100);
      };
    } else {
      // Fallback: download file if popup is blocked
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${fileName}.${fileExtension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }
  } catch (error) {
    console.error('Error opening file:', error);
    alert('❌ Fehler beim Öffnen der Datei. Bitte versuchen Sie es erneut.');
  }
};
